import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import Seo from '@/components/feature/Seo';
import ContactForm from '@/pages/contact/components/ContactForm';
import { site } from '@/mocks/site';

const jsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    name: '联系我们 | 瓜田黑料',
    url: 'https://changshazy.cn/contact',
    inLanguage: 'zh-CN',
    description: '通过表单或邮箱联系瓜田黑料，提交线索、内容纠错或商务合作。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: site.name,
    url: 'https://changshazy.cn/',
    email: site.email,
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://changshazy.cn/' },
      { '@type': 'ListItem', position: 2, name: '联系我们', item: 'https://changshazy.cn/contact' },
    ],
  },
];

const infoCards = [
  {
    icon: 'ri-mail-send-line',
    title: '合作与一般咨询',
    value: site.email,
    href: `mailto:${site.email}`,
    desc: '商务合作、内容授权、媒体采访等，请发到这里。',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: '线索投稿专线',
    value: site.submitEmail,
    href: `mailto:${site.submitEmail}`,
    desc: '带原始链接与时间点的材料会优先处理。',
  },
  {
    icon: 'ri-time-line',
    title: '回复时间',
    value: '两个工作日内',
    href: '',
    desc: '投稿量较大时可能稍有延迟，请耐心等待。',
  },
];

export default function Contact() {
  return (
    <SiteLayout>
      <Seo
        title="联系我们 | 瓜田黑料线索投稿与合作咨询"
        description="联系瓜田黑料：通过在线表单或邮箱提交娱乐热点线索、内容纠错与商务合作需求，我们会核对来源与时间点后尽快回复。"
        keywords="联系瓜田黑料,线索投稿,商务合作,内容纠错"
        path="/contact"
        jsonLd={jsonLd}
      />

      <section className="border-b border-background-200 bg-background-100/60">
        <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
          <nav aria-label="面包屑" className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
            <Link to="/" className="cursor-pointer hover:text-primary-700">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-800">联系我们</span>
          </nav>
          <h1 className="mt-4 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            联系我们
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            无论是爆料线索、内容纠错，还是合作咨询，都可以通过下面的表单或邮箱找到我们。
            我们更看重材料的完整度，而不是情绪强度。
          </p>
        </div>
      </section>

      <section className="bg-background-50">
        <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
            <div className="lg:col-span-7">
              <ContactForm />
            </div>

            <aside className="lg:col-span-5">
              <div className="space-y-4">
                {infoCards.map((card) => (
                  <div key={card.title} className="rounded-lg border border-background-200 bg-background-100/50 p-5">
                    <div className="flex items-start gap-3">
                      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                        <i className={`${card.icon} text-lg`}></i>
                      </span>
                      <div className="min-w-0">
                        <h2 className="font-heading text-base font-semibold text-foreground-950">{card.title}</h2>
                        {card.href ? (
                          <a
                            href={card.href}
                            className="mt-1 block cursor-pointer break-all text-sm text-primary-700 hover:underline"
                          >
                            {card.value}
                          </a>
                        ) : (
                          <p className="mt-1 text-sm text-foreground-800">{card.value}</p>
                        )}
                        <p className="mt-2 text-xs leading-relaxed text-foreground-600">{card.desc}</p>
                      </div>
                    </div>
                  </div>
                ))}

                <div className="rounded-lg bg-secondary-900 p-5 md:p-6">
                  <h2 className="font-heading text-base font-bold text-secondary-50">投稿小提示</h2>
                  <ul className="mt-3 space-y-2.5 text-xs leading-relaxed text-secondary-200">
                    <li className="flex gap-2">
                      <i className="ri-check-line mt-0.5 text-primary-300"></i>
                      保留原始链接，而不是转发后的截图。
                    </li>
                    <li className="flex gap-2">
                      <i className="ri-check-line mt-0.5 text-primary-300"></i>
                      标注大致时间点，方便我们排进时间线。
                    </li>
                    <li className="flex gap-2">
                      <i className="ri-check-line mt-0.5 text-primary-300"></i>
                      涉及他人的内容，请确认属于公开信息。
                    </li>
                  </ul>
                  <Link
                    to="/topics"
                    className="mt-5 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-secondary-700 px-4 py-2 text-sm text-secondary-100 transition-colors hover:bg-secondary-800"
                  >
                    <i className="ri-compasses-2-line"></i>
                    先去看看已有专题
                  </Link>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}